export default "__VITE_ASSET__Bteo9AKc__"